"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultAmountInputBoxStyle = void 0;
function getDefaultAmountInputBoxStyle(selector) {
    return __assign(__assign({ color: !selector.readOnly && selector.effectiveErrorMessage ? "red" : "black", height: "30px", border: "1px solid #b4b4b4", borderRadius: "3px", font: "normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif", outline: "rgb(131, 131, 131) none 0px", padding: "1px 30px 0px 10px" }, inputInvalidLocked(selector)), inputLocked(selector));
}
exports.getDefaultAmountInputBoxStyle = getDefaultAmountInputBoxStyle;
function inputInvalidLocked(_a) {
    var readOnly = _a.readOnly, effectiveErrorMessage = _a.effectiveErrorMessage;
    if (readOnly && effectiveErrorMessage) {
        return {
            background: "lightgray",
            color: "red",
            border: "none",
        };
    }
    return {};
}
function inputLocked(_a) {
    var readOnly = _a.readOnly, effectiveErrorMessage = _a.effectiveErrorMessage;
    if (readOnly && !effectiveErrorMessage) {
        return {
            background: "lightgray",
            color: "darkgray",
            border: "none",
        };
    }
    return {};
}
//# sourceMappingURL=default-styles.js.map